import React, { Component } from "react"
import { Container, Col, Row } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { LazyLoadImage } from "react-lazy-load-image-component"
import character_4 from "../../images/characters/character_4_white.png"




class DecouvrezMicrobioteIntestinal extends Component {



    render() {
        const t = this.props.t

        return (
            <>
                {/* Découvrez le microbiote intestinal */}
                <Container fluid className="bg-image bg-image-microbiote-intestinal  py-5">
                    <Container>
                        <h2 className="main-title-3 pb-5 center shadow-text">{t("microbiota|Decouvrez-0")}</h2>
                        <Row>
                            <Col md={6} className="center shadow-text">
                                <div className="white text-justify mb-3">{t("microbiota|Decouvrez-1")}</div>
                                <div className="white text-justify mb-3">{t("microbiota|Decouvrez-2")}</div>
                                <div className="white text-justify mb-3">{t("microbiota|Decouvrez-3")}</div>
                                <div className="white text-justify mb-4">{t("microbiota|Decouvrez-4")}</div>
                                <div className="white text-justify"><b>{t("microbiota|Decouvrez-5")}</b></div>
                            </Col>
                            <Col md={6} className="center">
                                <LazyLoadImage className="pt-4" alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={character_4} width="80px" />
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </>
        )
    }
}

export default withTranslation()(DecouvrezMicrobioteIntestinal)
